<template>
    <div class="inbox v-flex" v-if="!state.loading">
        <div class="invoice-view" ref="invoiceRef">
            <div class="hd">
                <div class="hdt">
                    <h2>{{ invoice.type }} Invoice</h2>
                    <p>#{{ invoice.no }}</p>
                </div>
                <div class="udtl">
                    <p><b> {{ office.name }} </b></p>
                </div>
            </div>
            <div class="cdtl">
                <p>
                    <strong v-if="invoice.type == 'Sales'">Customer:</strong> 
                    <strong v-else>Vendor:</strong> 
                    {{ invoice.customer_name }}</p>
                <p><strong>Due Date:</strong> {{ invoice.due_date }}</p>
                <p><strong>Issue Date:</strong> {{ invoice.invoice_date }}</p>
            </div>

            <table>
                <thead>
                    <tr class="head">
                    <th>Description</th>
                    <th>Quantity</th>
                    <th>Unit Price</th>
                    <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                    <td>{{ item.description }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ formatCurrency(item.unit_price) }}</td>
                    <td>{{ formatCurrency(item.total_price) }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="summary">
            <p><strong>Subtotal:</strong> {{ formatCurrency(invoice.subtotal) }}</p>
            <p><strong>Tax:</strong> {{ invoice.tax_percent }}%</p>
            <p><strong>Discount:</strong> {{ formatCurrency(invoice.discount) }}</p>
            <p><strong>Total:</strong> {{ formatCurrency(invoice.total) }}</p>
            <p v-if="invoice.deposit > 0"><strong>Paid:</strong> {{ formatCurrency(invoice.deposit) }}</p>
            <p v-if="invoice.deposit > 0 && invoice.balance > 0"><strong>Balance:</strong> {{ formatCurrency(invoice.balance) }}</p>
            </div>
        </div>
        <div class="ibtns">
            <span @click="downloadPDF" v-if="!state.downloading">Download PDF</span>
            <img v-else src="@/assets/img/ajldr.gif" style="width:50px"/>
            <span @click="editInvoice">Edit Invoice</span>
            <span @click="depositHistory">Deposit History</span>
        </div>
    </div>
    <div v-else style="text-align: center;">
        <img src="@/assets/img/ajldr.gif" style="width:100px"/>
    </div>
</template>

<script>
import { ref, onMounted, reactive, computed } from 'vue'
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { useRoute } from 'vue-router';
import html2pdf from 'html2pdf.js'
import { useRouter } from 'vue-router';
export default{
    name:"ViewInvoice",
    setup(){
        const router = useRouter();
        const state=reactive({loading:true,downloading:false});
        const invoice = ref({})
        const items = ref([])
        const office = ref([])
        const route = useRoute();
        const invoiceRef = ref(null)
        const id = computed(() => route.params.id)
        function formatCurrency(amount) {
            return '₦' + parseFloat(amount).toLocaleString(undefined, { minimumFractionDigits: 2 })
        }

        onMounted(() => {
            call({
                url:urls.transactions,
                data:{viewInvoice:id.value},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        var d=res.msg;
                        var inv=d.invoice;
                        invoice.value={
                            type:inv.type,
                            no: inv.no,
                            customer_name: inv.name,
                            invoice_date: inv.date,
                            due_date: inv.due,
                            tax_percent: inv.tax,
                            discount: inv.discount,
                            total: inv.total,
                            subtotal:inv.subtotal,
                            deposit:inv.deposit,
                            balance:inv.balance
                        }
                        items.value.length=0;
                        Object.keys(d.items).forEach(k => {
                            items.value.push(d.items[k])
                        })
                        var o=d.office;
                        office.value={
                            name:o.name
                        }
                    }else{
                        alert(res.msg);
                    }
                }
            })
        })

        function downloadPDF() {
            state.downloading=true;
            const element = invoiceRef.value
            element.classList.add('pdf-export');
            const opt = {
                margin: 0,
                filename: `${office.value.name} invoice-${invoice.value.no}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: {
                scale: 2,
                useCORS: true
                },
                jsPDF: {
                unit: 'mm',
                format: 'a4',
                orientation: 'portrait'
                },
                pagebreak: { mode: ['css', 'legacy'] }
            };

            html2pdf().set(opt).from(element).save().then(() => {
                // Remove export-only class after saving
                element.classList.remove('pdf-export');
                state.downloading=false;
            });
        }

        function editInvoice(){
            router.push({ name: 'editinvoice', params: { id: id.value} });
        }
        function depositHistory(){
            router.push({ name: 'invoicehistory', params: { id: id.value } });
        }
        return{
            invoice,items, formatCurrency,state,office,invoiceRef,
            downloadPDF,depositHistory,editInvoice
        }
    }
}
</script>

<style scoped>
.invoice-view {
    width: 700px;
    padding: 1rem;
    background: var(--white-color);
    color: var(--black);
    position:relative;
}
.hd{display: flex; width: 100%; justify-content: space-between;
    align-items: center;}
.hd p, .cdtl p{margin:0}
.hd h2{margin:0}
.cdtl{margin-top: 20px;}
.hdt p{margin-top: -5px; font-weight: bold;}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  margin-bottom: 25mm;
}
th, td {
  padding: 8px;
  text-align: left;
}
tr:nth-child(odd):not(.head) {
    background: var(--light-row-color);
}
tr:nth-child(2n) {
    background: var(--white-color);
}
.summary {
  margin-top: 1rem;
  text-align: right;
}
.summary p{margin:0}

.pdf-export{
    background: white;
    color: #212529;
    
    width: 210mm;
    min-height: 297mm;
    padding: 20mm;
    box-sizing: border-box;
  }
.pdf-export .hd h2{color:black}
.pdf-export tr:nth-child(odd):not(.head) {
    background: #e5e5e5;
  }
.pdf-export tr:nth-child(2n) {background:white}
.pdf-export .summary{position: absolute; right: 20mm;
    bottom: 20mm;}
.ibtns{padding:0 10px 10px}
.ibtns span{display:block;background: var(--white-color); cursor:pointer;
    color: var(--black); padding: 10px 15px; margin-bottom: 5px; border-radius: 5px;}
table {
        page-break-inside: auto;
    }
    tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }
    td, th {
        page-break-inside: avoid;
    }
@media print {
  .invoice-view{
    background: white;
    color: #212529;
  }
  .hd h2{color:black}
  tr:nth-child(odd):not(.head) {
    background: #e5e5e5;
  }
  tr:nth-child(2n) {background:white}
  body {
    margin: 0;
  }
  .invoice-view {
    width: 210mm;
    min-height: 297mm;
    padding: 20mm;
    box-sizing: border-box;
  }
  .summary{position: absolute; right: 20mm;
    bottom: 20mm;}
}

</style>
